import React from "react";
import { CloudOff, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";
import Button from "./Button";

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  /** Sahifa ichidagi kichik seksiya uchun ixcham ko'rinish */
  compact?: boolean;
}

const ErrorState: React.FC<ErrorStateProps> = ({ title, description, onRetry, compact }) => {
  const { t } = useTranslation();

  if (compact) {
    return (
      <div className="flex items-center gap-3 rounded-2xl border border-line bg-surface-2 px-4 py-3">
        <CloudOff size={18} className="text-content-tertiary shrink-0" />
        <p className="flex-1 text-xs font-medium text-content-secondary">
          {title || t("common.error")}
        </p>
        {onRetry && (
          <Button variant="ghost" size="sm" icon={RefreshCw} onClick={onRetry}>
            {t("common.retry")}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-inset flex items-center justify-center mb-4">
        <CloudOff size={28} className="text-content-tertiary" />
      </div>
      <h3 className="text-base font-bold text-content-primary mb-1">
        {title || t("common.error")}
      </h3>
      <p className="text-sm text-content-tertiary max-w-[260px]">
        {description || t("common.errorDescription")}
      </p>
      {onRetry && (
        <Button variant="secondary" size="md" icon={RefreshCw} onClick={onRetry} className="mt-5">
          {t("common.retry")}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
